<template>
  <div>
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">
          会员等级
        </div>
      </div>
      <div style="padding: 20px;">
        <!-- 查询条件 -->
        <div style="margin:5px 0 20px 35px;">
          <el-form label-width="100px">
            <el-form-item>
              <el-radio
                v-model="queryForm.evaluateTime"
                @change="timeChange"
                v-for="item in options.evaluateTimeOpt"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
               <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="postForm.startDate"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            :disabled=" queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px;font-size:12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text"  :class="{'to_text_disabled': queryForm.evaluateTime != 0 || !queryForm.evaluateTime}" >至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="postForm.endDate"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px;font-size:12px"
            class="time2"
            :clearable="true"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
              <el-button
                class="b1"
                style="margin-left:8px;"
                v-zoom='{from:pageName,name:"查询"}'
                @click="query()"
                ><span style="marginLeft:4px;">
                  <i
            class="el-icon-search"
            style="display:inline-block;width:14px;height:12px;margin-right:4px;"
          ></i>查询</span></el-button
              >
              <el-button
                class="b2"
                style="margin-left:8px;"
                @click="queryOne()"
                ><span style="marginLeft:4px;">重置</span></el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- 提示栏 -->
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">会员分布</span>
        </div>
        <!-- 图表数据 -->
        <div v-loading="loading">
        <div  >
          <div class="float">
            &nbsp; <span class="peopleStyle">{{ people }}</span
            >人&nbsp;&nbsp;&nbsp;
            <span>
              <span class="lineDi"></span>
              更新时间：{{ updataTime }}</span
            >
          </div>
          <div
            id="order-care"
            :style="{ width: '100%', height: '400px' }"
          ></div>
        </div>
        <!-- 列表表格 -->
        <div style="margin-top:30px;">
          <el-table
              
            :data="recordData"
            style="width:100%;opacity:1;"
            tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
          >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column width="30"></el-table-column>
            <el-table-column
              prop="gradeName"
              label="会员等级"
            ></el-table-column>
            <el-table-column
              prop="memberCount"
              label="会员数"
            ></el-table-column>
            <el-table-column
              prop="buyTotalCount"
              label="订单数"
            ></el-table-column>
            <el-table-column label="成交金额（元）" prop="buyTotalMoney">
            </el-table-column>
            <el-table-column label="客单价（元）" prop="unitPrice">
            </el-table-column>
            <el-table-column label="占比" prop="proportion"> </el-table-column>
          </el-table>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { buyerGradeCount } from "@/api/analysis/monthly-report";
export default {
  name: "monthly_report",
  data() {
    return {
      pageName:"数据分析-会员等级",
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      loading:true,
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "",
            label: "全部",
          },
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "30",
            label: "近一个月",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      queryForm: {
        evaluateTime: "30",
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      mytime: [],
      zxData: {
        timeFlag: [],
        buyerCount: [],
        tradeCount: [],
        payment: [],
        buyerAvgCost: [],
      },
      recordData: [],
      people: 0,
      updataTime: "",
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  mounted: function() {
    this.timeChange(30);
    this.query();
    this.updataTime = this.getNowDate();
    this.$nextTick(() => {
      this.drawOrderCareBar();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    //当前时间
    getNowDate() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();

      if (Hours >= 0 && Hours <= 9) {
        Hours = "0" + Hours;
      }
      if (Minutes >= 0 && Minutes <= 9) {
        Minutes = "0" + Minutes;
      }
      if (Seconds >= 0 && Seconds <= 9) {
        Seconds = "0" + Seconds;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        Hours +
        seperator2 +
        Minutes +
        seperator2 +
        Seconds;
      return currentdate;
    },
    //查询
    query() {
      this.loading=true;
      let self = this;
      buyerGradeCount(this.postForm)
        .then((res) => {
          this.loading=false;
          this.people = 0;
          res.data.forEach((a, b) => {
            this.people += a.memberCount;
          });
          this.recordData = res.data;
          self.zxData.timeFlag = [];
          self.zxData.buyerCount = [];
          self.zxData.tradeCount = [];
          res.data.forEach((val, index) => {
            self.zxData.timeFlag.push(val.proportion); //时间段日期
            self.zxData.buyerCount.push(val.gradeName); //会员数
            self.zxData.tradeCount.push(val.memberCount); //订单数
          });
          self.drawOrderCareBar();
        })
        .catch(() => {});
    },
    //重置
    queryOne() {
      this.queryForm.evaluateTime = "";
      this.postForm.startDate = "";
      this.postForm.endDate = "";
      this.query();
    },
    //时间限制
    clearTimeSendTime(){
      this.postForm.startDate='';
      this.postForm.endDate='';
    },
    timeChange(type) {
      let self = this;
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      if (type == 7) {
        this.postForm.startDate = this.mytime[0];
        this.postForm.endDate = this.mytime[1];
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = this.mytime[0];
        this.postForm.endDate = this.mytime[1];
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    //绘制柱状图
    drawOrderCareBar() {
      let self = this;
      let orderCareBarChartOne = this.$echarts.init(
        document.getElementById("order-care"),
        "light"
      ); //初始化echats实例
      orderCareBarChartOne.setOption({
        // tooltip: {
        //   trigger: "axis",
        //   axisPointer: {
        //     type: "shadow", // 默认为直线，可选为：'line' | 'shadow'

        //   },
        //   barWidth:20
        // },
        // legend: {
        //   data: ["会员数", "订单数"],
        //   left: 130,
        //   top: 1,
        //   itemWidth: 8,
        //   itemHeight: 8,
        //   icon: "circle",
        // },
        // xAxis: {
        //   // x轴
        //   type: "category",
        //   name: "金额区间",
        //   data: self.zxData.timeFlag,
        // },
        // yAxis: {
        //   // y轴
        //   type: "value",
        // },
        // series: [
        //   {
        //     name: "会员数",
        //     data: self.zxData.buyerCount,
        //     type: "bar",
        //     smooth: true,
        //     color: ["#4CDFC0"],
        //     stack: "总量",
        //     barWidth: 20,
        //   },
        //   {
        //     name: "订单数",
        //     data: self.zxData.tradeCount,
        //     type: "bar",
        //     smooth: true,
        //     stack: "总量",
        //     color: ["#4878FF"],
        //     barWidth: 20,
        //   },
        // ],
        // title: {
        //   text: this.people+`人`,
        //   subtext: "数据来自网络",
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          data: self.zxData.timeFlag,
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        yAxis: {
          type: "category",
          data: self.zxData.buyerCount,
        },
        series: [
          {
            type: "bar",
            barWidth: 20, //柱图宽度
            data: self.zxData.tradeCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666",
                    fontSize: 14,
                  },
                },
                color: function(params) {
                  var colorList = [
                    "#FF6B6B",
                    "#36CBCB",
                    "#FFCB7B",
                    "#FF974A",
                    "#4878FF",
                    "#DBE2E7",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      });
      window.onresize = function() {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__content {
  margin-left: -30px !important;
}
.section-right-content-box {
  min-width: 1046px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;
  .background {
    height: 32px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    line-height: 32px;
    padding-left: 12px;
    margin-top: 26px;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: rgba(254, 77, 69, 1);
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }
  .b1{
    width: 98px;
      height: 32px;
      color: #fe4d45;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #fe4d45 ;
      background-color: #fff;
   &:hover{
      color: #fff ;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .b2{
    width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
    &:hover{
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
    }
  }
  .echarts {
    width: 100%;
    height: 40px;
    background: #fafafa;
    opacity: 1;
    padding-left: 20px;
    line-height: 40px;
  }
  .clos {
    width: 100%;
    height: 310px;
    background: #ffffff;
    border: 1px solid #f3f4f7;
    opacity: 1;
    padding-left: 20px;
  }
  .float {
    position: relative;
    top: 30px;
    .peopleStyle {
      width: 65px;
      height: 25px;
      font-size: 18px;
      font-weight: 500;
      line-height: 25px;
      color: #333333;
      opacity: 1;
    }
    .lineDi {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      vertical-align: middle;
      background-color: red;
      display: inline-block;
    }
  }
}
</style>
